<div class="orders-sheet">
  <div class="orders-sheet__header">
    <h2 class="orders-sheet__title"><mat-icon>shopping_bag</mat-icon> Mes commandes</h2>
    <button mat-icon-button (click)="close()" aria-label="Fermer"><mat-icon>close</mat-icon></button>
  </div>

  <div class="orders-sheet__content">
    <mat-accordion>
      <mat-expansion-panel *ngFor="let c of commandes">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon class="orders-sheet__icon">receipt</mat-icon>
            #{{ c.idCommande }}
          </mat-panel-title>
          <mat-panel-description>{{ c.date | date:'dd/MM/yyyy' }} — {{ c.montant }}€</mat-panel-description>
        </mat-expansion-panel-header>
        <div class="orders-sheet__detail">
          <div class="orders-sheet__detail-row"><span>Pour</span><span>{{ c.prenom }} {{ c.nom }} (Socio#{{ c.idTechSocio }})</span></div>
          <div class="orders-sheet__detail-row"><span>Taille</span><span>{{ c.taille }}</span></div>
          <div class="orders-sheet__detail-row"><span>Prix</span><span>{{ c.montant }}€ par {{ c.moyenPaiement }}</span></div>
          <div class="orders-sheet__detail-row"><span>Livraison</span><span>{{ c.livraison }}</span></div>
          <div class="orders-sheet__detail-row" *ngIf="isDelivery(c.livraison)">
            <span>Adresse</span><span>{{ c.adresse }} — {{ c.codePostal }} {{ c.commune }} ({{ c.pays }})</span>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
